(function () {
  function initSection(sectionEl) {
    function init() {
      const courtin = sectionEl.querySelector('.masp_courtin');
      if (courtin) {
        const delay = parseInt(courtin.getAttribute('data-delay'), 10) || 2000;
        sectionEl.style.overflow = 'hidden';
        setTimeout(function () {
          courtin.classList.add('open-courtin');
          setTimeout(function () {
            courtin.classList.add('hidden');
            sectionEl.style.overflow = '';
          }, 2000);
        }, delay);
      }

      const header = sectionEl.querySelector('.masp_header .header');
      if (!header) return;

      const headerLink = sectionEl.querySelector('.masp_header .header-z-link');
      const logoWrapper = header.querySelector('.o_logo_zrzs_masp');

      const expandedBottom = header.getBoundingClientRect().bottom;

      if (logoWrapper) logoWrapper.style.transition = 'none';
      header.classList.add('reduced');
      const reducedBottom = header.getBoundingClientRect().bottom;
      header.classList.remove('reduced');
      if (logoWrapper) logoWrapper.style.transition = '';

      sectionEl.style.setProperty('--banner-expanded-top', expandedBottom + 'px');
      sectionEl.style.setProperty('--banner-reduced-top', reducedBottom + 'px');

      let isReduced = false;
      const REDUCE_AT = 80;
      const EXPAND_AT = 20;

      function setReduced(reduced) {
        if (reduced === isReduced) return;
        isReduced = reduced;
        sectionEl.classList.toggle('header-reduced', reduced);
        header.classList.toggle('reduced', reduced);
        if (headerLink) {
          if (reduced) {
            setTimeout(function () {
              if (isReduced) headerLink.classList.add('visible');
            }, 1000);
          } else {
            headerLink.classList.remove('visible');
          }
        }
      }

      if ('IntersectionObserver' in window) {
        const topSentinel = document.createElement('div');
        topSentinel.setAttribute('aria-hidden', 'true');
        topSentinel.style.cssText =
          'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
        sectionEl.prepend(topSentinel);
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) setReduced(false);
        }).observe(topSentinel);
      }

      window.addEventListener('scroll', function () {
        const s = window.scrollY;
        if (!isReduced && s > REDUCE_AT) setReduced(true);
        else if (isReduced && s <= EXPAND_AT) setReduced(false);
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }

  document.querySelectorAll('[id^="lp-masp-header-"]').forEach(initSection);
})();
